import { render, staticRenderFns } from "./ConsumoIA.vue?vue&type=template&id=13800f44&lang=pug"
import script from "./ConsumoIA.vue?vue&type=script&lang=js"
export * from "./ConsumoIA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports